import axios from "@/plugins/axios";

import admins from "./admins";
import cashes from "./cashes";
import common from "./common";
import cps from "./cps";
import dashboard from "./dashboard";
import greenp from "./greenp";
import levels from "./levels";
import members from "./members";
import messages from "./messages";
import partners from "./partners";
import pins from "./pins";
import setting from "./setting";
import shop from "./shop";
import terms from "./terms";
import userExchanges from "./user-exchanges";
import users from "./users";

export default {
    admins,
    cashes,
    common,
    cps,
    dashboard,
    greenp,
    levels,
    members,
    messages,
    partners,
    pins,
    setting,
    shop,
    terms,
    userExchanges,
    users,
    email: {
        post({ to, subject, html }) {
            return axios.post("/api/console/email", { to, subject, html }).then((result) => result.data);
        },
    },
    message: {
        post({ to, subject, message }) {
            return axios.post("/api/console/message", { to, subject, message }).then((result) => result.data);
        },
    },
};
